import { apiProxyRequest as request } from "Api/apiProxyRequest";
import { OrganizationProject } from "Api/organizations/projects/OrganizationProjects.types";

export interface CreateOrganizationProjectBody {
  region: string;
  title: string;
  default_branch?: string;
  // `null` creates a flexible (usage-based) project; the projects service
  // routes to the subscription internally for fixed projects.
  plan?: string | null;
  type?: string;
  options_custom?: Record<string, unknown>;
}

export const createOrganizationProject = async (
  organizationId: string,
  body: CreateOrganizationProjectBody
) =>
  await request<OrganizationProject>(
    `/organizations/${organizationId}/projects`,
    "POST",
    body
  );
